import { render, staticRenderFns } from "./indexTournament.vue?vue&type=template&id=7a0e4cb8&scoped=true&"
import script from "./indexTournament.vue?vue&type=script&lang=js&"
export * from "./indexTournament.vue?vue&type=script&lang=js&"
import style0 from "./indexTournament.vue?vue&type=style&index=0&id=7a0e4cb8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0e4cb8",
  null
  
)

export default component.exports